import React, { useEffect, useState } from "react";
import ReactSelect from "react-select";
import { ModalBody } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import CloudStorage from "../../../../CloudStorage/CloudStorage";
import { updateProfile } from "../../../../redux/profile/action";
import { getIndustry } from "../../../../redux/categary/action";

export default function ProfileModelIndustry({
  edittype,
  formData,
  setFormData,
  setModelIndustry,
}) {
  const [validation, setValidation] = useState(false);
  const [popularIndustries, setPopularIndustries] = useState("");
  const [allIndustries, setAllIndustry] = useState("");
  const [selectIndustry, setSelectIndustry] = useState(null);
  const [selectedIndustry, setSelectedIndustry] = useState(
    formData.industries || [],
  );
  const [manualIndustry, setManualIndustry] = useState("");
  const [addManual, setAddManual] = useState(false);
  const Industryss = useSelector(
    ({ categary: { industrylist } }) => industrylist,
  );
  const dispatch = useDispatch();

  useEffect(() => {
    setAllIndustry(Industryss);
    setPopularIndustries(Industryss);
  }, [Industryss]);

  useEffect(() => {
    dispatch(getIndustry());
  }, [dispatch]);

  const handleIndustryChange = (selectedOption) => {
    const newIndustry = {
      id: selectedOption.value,
      title: selectedOption.label,
    };
    setSelectedIndustry([...selectedIndustry, newIndustry]);
    setSelectIndustry(null);
  };

  const handleAddPopularIndustry = (industry) => {
    const newIndustry = {
      id: industry.id,
      title: industry.title,
    };
    setSelectedIndustry([...selectedIndustry, newIndustry]);
  };

  const handleDeleteIndustry = (id) => {
    const updatedIndustries = selectedIndustry.filter(
      (industry) => industry.id !== id,
    );
    setSelectedIndustry(updatedIndustries);
  };

  const handleAddManualIndustry = () => {
    if (manualIndustry.trim() == "") return;
    const newIndustry = {
      id: manualIndustry.trim(),
      title: manualIndustry.trim(),
    };
    setSelectedIndustry([...selectedIndustry, newIndustry]);
    setManualIndustry("");
    setAddManual(false);
  };

  const handleSave = () => {
    if (selectedIndustry.length >= 1) {
      setFormData((prevData) => ({
        ...prevData,
        industries: selectedIndustry,
      }));

      const data = {
        type: "industries",
        industries: selectedIndustry,
      };
      if (edittype === 1) {
        dispatch(updateProfile(data));
      }
      setModelIndustry(false);
    } else {
      setValidation(true);
    }
  };

  return (
    <>
      <button
        onClick={() => setModelIndustry(false)}
        className="btn close-button"
      >
        <img
          src={`${CloudStorage.cloudurl}/Assets/Images/common/close-icon.svg`}
          alt=""
        />
      </button>
      <ModalBody>
        <h4>Edit Industry</h4>
        <div>
          <div className="form-group">
            <label className="label">Search or add industries</label>
            <ReactSelect
              options={
                Array.isArray(allIndustries) &&
                allIndustries
                  .filter(
                    (industry) =>
                      !selectedIndustry.some(
                        (selected) => selected.id == industry.id,
                      ),
                  )
                  .map((industry) => ({
                    value: industry.id,
                    label: industry.title,
                  }))
              }
              placeholder="Select industries"
              isClearable={true}
              value={selectIndustry}
              onChange={(options) => {
                if (options) {
                  handleIndustryChange(options);
                }
              }}
            />
            <p>Add up to 5 industries for best results</p>

            {validation && (
              <p style={{ color: "red" }}>Please add at least 1 industry</p>
            )}

            <div className="add-skills">
              {Array.isArray(selectedIndustry) &&
                selectedIndustry.map((industry, index) => (
                  <div
                    key={index}
                    onClick={() => {
                      handleDeleteIndustry(industry.id);
                    }}
                  >
                    <p>
                      {industry.title} <span>x</span>
                    </p>
                  </div>
                ))}
            </div>
            <div className="popular-skill">
              <h5 className="mt-2">Popular Industries</h5>
              <div className="add-skills">
                {Array.isArray(popularIndustries) &&
                  popularIndustries
                    .filter(
                      (industry) =>
                        !selectedIndustry.some(
                          (selected) => selected.id === industry.id,
                        ),
                    )
                    .map((industry, index) => (
                      <div
                        key={index}
                        onClick={() => {
                          handleAddPopularIndustry(industry);
                        }}
                      >
                        <p>
                          {industry.title} <span>+</span>
                        </p>
                      </div>
                    ))}
              </div>
            </div>
            <a
              className="add-plus btn"
              onClick={() => {
                setAddManual(true);
              }}
            >
              + Add Industry Manually
            </a>
            {addManual && (
              <div className="manualskill-input">
                <input
                  type="text"
                  value={manualIndustry}
                  style={{ width: "70%" }}
                  onChange={(e) => setManualIndustry(e.target.value)}
                  placeholder="Type an industry and press add"
                />
                <button onClick={handleAddManualIndustry}>
                  Add
                </button>
                <button
                  
                  onClick={() => {
                    setAddManual(false);
                  }}
                >
                  Close
                </button>
              </div>
            )}
          </div>
        </div>
      </ModalBody>
      <div className="modal-footer mt-3">
        <button className="btn" onClick={handleSave}>
          Save
        </button>
      </div>
    </>
  );
}
